<script setup lang="ts">
import type { InputNumberProps } from "./inputNumber.types";
import { useInputNumber } from "./useInputNumber";
import { useSlotPresence } from "@/runtime/composables/useSlotPresence";

defineOptions({ name: "EInputNumber", inheritAttrs: false });

const props = withDefaults(defineProps<InputNumberProps>(), {
  type: "number",
  autocomplete: "off",
  autofocusDelay: 0,
  color: "neutral",
  variant: "subtle",
  size: "md",
  block: false,
  disabled: false,
  required: false,
  step: 1,
});

const { leading: hasLeading, trailing: hasTrailing } = useSlotPresence(["leading", "trailing"]);

const { state, handleIncrement, handleDecrement } = useInputNumber(props);
</script>

<template>
  <e-group :size="state.size?.value">
    <e-input
      :model-value="state.modelValue?.value"
      :color="state.color?.value"
      :variant="state.variant?.value"
      :size="state.size?.value"
      :block="state.block?.value"
      :disabled="state.disabled?.value"
      :required="state.required?.value"
      :name="state.name?.value"
      :placeholder="state.placeholder?.value"
      :min="state.min?.value"
      :max="state.max?.value"
      :step="state.step?.value"
      :autocomplete="state.autocomplete?.value"
      type="number"
    >
      <span v-show="hasLeading" slot="leading">
        <slot name="leading" />
      </span>
      <slot />
      <span v-show="hasTrailing" slot="trailing">
        <slot name="trailing" />
      </span>
    </e-input>

    <e-button
      square
      icon="minus"
      :size="state.size?.value"
      :variant="state.variant?.value"
      :color="state.color?.value"
      :disabled="state.disabled?.value"
      type="button"
      @click="handleDecrement"
    />

    <e-button
      square
      icon="add"
      :size="state.size?.value"
      :variant="state.variant?.value"
      :color="state.color?.value"
      :disabled="state.disabled?.value"
      type="button"
      @click="handleIncrement"
    />
  </e-group>
</template>
